export const extractLastItemFromPath = (path) => {
  try {
    return typeof path === "string" ? path.split("/").slice(-1).toString() : "";
  } catch (error) {}
};

export const removeExtension = (filename) => {
  try {
    if (typeof filename !== "string")
      throw new Error("Invalid filename typeof, expected an String");
    const lastDotIndex = filename.lastIndexOf(".");
    if (lastDotIndex === -1) return filename; // No dot found, return original filename
    return filename.substring(0, lastDotIndex);
  } catch (error) {}
};

export const getBannerIdFromURL = (bannerURL) => {
  try {
    return removeExtension(extractLastItemFromPath(bannerURL));
  } catch (error) {}
};
